import {
	Component,
	Inject,
	Input,
	OnChanges
} from '@angular/core';

import { VideogularComponent } from '../Videogular.Component';
import { VBRICK_PLAYER_HOST } from '../../VbPlayerHostToken';
import { VG_VOLUME_COMPONENT_TOKEN } from './VgVolumeComponentToken';

const CHANGE_PER_PRESS = 0.05;

@Component({
	selector: 'vg-mute-button',
	template: `
	<button
		type="button"
		[attr.aria-label]="isMuted ? vbrickPlayer.translations.unmute : vbrickPlayer.translations.mute"
		[tooltip]="isMuted ? vbrickPlayer.translations.unmute : vbrickPlayer.translations.mute"
		[placement]="'top'"
		[ngClass]="[
			'button',
			'vb-icon',
			isBelowMidLevel ? 'vb-icon-volume-half' : '',
			isAboveMidLevel ? 'vb-icon-volume-full' : '',
			isMuted ? 'vb-icon-volume-mute' : ''
		]"
		vbControlBarFocus
		(click)="onClickMute()"
		(keydown)="vgVolume.onVolumeAreaKeyDown($event)">
	</button>
	`,
	standalone: false,
	styleUrls: ['./VgMuteButton.Component.ng.less']
})
export class VgMuteButtonComponent implements OnChanges {
	@Input() public currentVolume: number;

	constructor(
		@Inject(VBRICK_PLAYER_HOST)
		public vbrickPlayer: any,
		public vgApi: VideogularComponent,
		@Inject(VG_VOLUME_COMPONENT_TOKEN)
		public vgVolume: any
	) {}

	public ngOnChanges(): void {
		this.onSetVolume(this.currentVolume);
	}

	private get currentVolumePercent(): number {
		return Math.round(this.currentVolume * 100);
	}

	public get isBelowMidLevel(): boolean {
		return !this.isMuted && this.currentVolumePercent < 50;
	}

	public get isAboveMidLevel(): boolean {
		return this.currentVolumePercent >= 50;
	}

	public get isMuted(): boolean {
		return this.vgApi.isMuted;
	}

	public onClickMute(): void {
		this.vgApi.toggleSound();
		this.vgVolume.storeVolumePreference();
	}

	private onSetVolume(newVolume: number): void {
		// if it's not muted we save the default volume OR if was muted but the user changed the volume
		if (!this.isMuted || newVolume > 0) {
			this.vgApi.defaultVolume = newVolume;
		}
	}
}
